export default "__VITE_ASSET__BHKbo41h__"